module.exports = __webpack_public_path__ + "img/m1.0c62735f.png";